import { GlobalConfig } from './global-config.enum';
import { SaveMode } from './save-mode.enum';

const enums = {
  SaveMode,
  GlobalConfig
};

export default enums;
